/**
 * Created by neo on 12.04.22.
 */
import { makeAutoObservable, onBecomeObserved, runInAction } from 'mobx';
import { v4 as UUID } from 'uuid';
import { MindfulnessProgramTemplateDayUnit, createMindfulnessProgramTemplateDayUnit } from './MindfulnessProgramTemplateDayUnit';
import { Instructor, createInstructor } from '../../../Explore/Instructor';
import { Media, createMedia } from '../../../Media/Media';
import { ActivityApi } from '../../../Activity/Activity';

export type MindfulnessProgramTemplateDayUnitVideo = MindfulnessProgramTemplateDayUnit & {
  instructor: Instructor;
  videos: Media[];
  spotifyPlaylistLink?: string;
  getVideo(lang: string): Media | undefined;
};

export function createMindfulnessProgramTemplateDayUnitVideo(json?: Partial<MindfulnessProgramTemplateDayUnitVideo>): MindfulnessProgramTemplateDayUnitVideo {
  const base = createMindfulnessProgramTemplateDayUnit({ ...json, type: 'video' } as any);
  const unit: MindfulnessProgramTemplateDayUnitVideo = makeAutoObservable({
    ...base,
    instructor: createInstructor(json?.instructor as any),
    videos: (json?.videos ?? []).map((a: any) => createMedia(a)),
    spotifyPlaylistLink: json?.spotifyPlaylistLink,

    getVideo(lang: string): Media | undefined {
      const languageVideo = this.videos.find((a) => a.language?.toLowerCase() === lang.toLowerCase());
      const germanVideo = this.videos.find((a) => a.language?.toLowerCase() === 'de');
      return languageVideo ?? germanVideo ?? this.videos[0];
    },

    toJS(newId: boolean = false) {
      return {
        ...(function() { const { id, createdAt, updatedAt, createdBy, updatedBy, name, description } = base; return { id: newId ? UUID() : id, createdAt, updatedAt, createdBy, updatedBy, name, description }; })(),
        instructor: this.instructor,
        videos: this.videos.map((a) => a),
        activityIdentifier: this.activityIdentifier,
        spotifyPlaylistLink: this.spotifyPlaylistLink,
      };
    },
  });

  onBecomeObserved(unit, 'activity', () => {
    if (!unit.activity) {
      ActivityApi.get(unit.activityIdentifier).then((result) => runInAction(() => (unit.activity = result)));
    }
  });

  return unit;
}
